'use strict';

angular.module('AcaApp').controller('ResetDataController',
[
  '$scope',
  'ResetDataService',
  '$mdDialog',
  'currentEntity',
  'LayoutService',
  'SETTINGS',
  'taxYear',
  function($scope, ResetDataService, $mdDialog, currentEntity, LayoutService, SETTINGS, taxYear){
    LayoutService.setBody('left-column-gray');

    $scope.isChecked = false;
    $scope.checkReset = false;
    $scope.taxYear = taxYear;

    switch(currentEntity){
      case 'P':
        $scope.entity = 'Form and Participant';
      break;
      case 'F':
        $scope.entity = 'Form';
      break;
      case 'E':
        $scope.entity = 'Form, Participant and Employer/Issuer';
      break;
    }

    $scope.resetData = function(){
      if($scope.checkReset){
        $mdDialog.hide();
        ResetDataService.resetCurrentData(currentEntity).then(function(){
          showSuccessfully();
        },
        function(error){
          $mdDialog.show({
            scope: $scope,
            preserveScope: true,
            locals: {
              error: error.data.error
            },
            controller: [
              '$scope',
              '$rootScope',
              '$mdDialog',
              'error',
              function($scope, $rootScope, $mdDialog, error){
                $scope.error = error;
                $scope.closeModal = function(){
                  $mdDialog.hide();
                };
              }
            ],
            templateUrl: 'app/views/settings/modals/error-reset.html'
          });
        });
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/settings/modals/processing-reset.html',
          parent: angular.element(document.body)
        });
      }
      else{
        $scope.isChecked = true;
      }
    };

    $scope.checkErrorMsg = function(){
      if($scope.checkReset){
        $scope.isChecked = false;
      }
    };

    $scope.closeModal = function(){
      $mdDialog.hide();
    };

    var showSuccessfully = function(){
      $mdDialog.show({
        scope: $scope,
        preserveScope: true,
        controller: [
          '$scope',
          '$rootScope',
          '$mdDialog',
          function($scope, $rootScope, $mdDialog){
            $scope.closeModal = function(){
              $mdDialog.hide();
              successfullyReset();
            };
          }
        ],
        templateUrl: 'app/views/settings/modals/successfully-reset.html'
      });
    };

    var successfullyReset = function(){
      if(currentEntity === 'P'){
        $scope.buttonResetTextPart = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledPart = true;
        $scope.buttonResetTextForm = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledForm = true;
      }

      if(currentEntity === 'F'){
        $scope.buttonResetTextForm = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledForm = true;
      }

      if(currentEntity === 'E'){
        $scope.buttonResetTextEmp = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledEmp = true;
        $scope.buttonResetTextPart = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledPart = true;
        $scope.buttonResetTextForm = SETTINGS.DATASUCCESSFULLY;
        $scope.buttonResetEnabledForm = true;
      }
    };
  }
]);